export default __webpack_public_path__ + "static/media/photo2.733d23cd.jpg";